import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=d5b0ab0e&scoped=true&"
var script = {}
import style0 from "./AdditionalInfo.vue?vue&type=style&index=0&id=d5b0ab0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b0ab0e",
  null
  
)

export default component.exports